import { BRANCH_W, INK_SOFT } from '../timelineDiagramGeometry'
import { type PerspectivePlacement } from '../timelineDiagramLayout'
import { ARROWHEAD_MARKER_URL } from './ArrowheadMarker'

// Public/Insider POVs as their own full-width tracks: each peels DOWN off the
// spine's left start and runs below it, capped with an arrowhead past its label.
// Drawn soft so the Plan A spine stays the dominant line. Positions come from
// PLACEMENT.
export const PerspectiveTracks = ({ perspectives }: { perspectives: PerspectivePlacement[] }) => (
  <>
    {perspectives.map(({ entry, track }) => (
      <path
        key={entry.label}
        d={track}
        stroke={INK_SOFT}
        strokeWidth={BRANCH_W}
        markerEnd={ARROWHEAD_MARKER_URL}
      />
    ))}
  </>
)
